var _path, _path2, _path3, _circle, _circle2, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItSupportANdMaintainanceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 36,
    viewBox: "0 0 43 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 26V12C8 5.92487 12.9249 1 19 1H24C30.0751 1 35 5.92487 35 12V26.5",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 26C4.35786 26 1 22.6421 1 18.5C1 14.3579 4.35786 11 8.5 11",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35 26C39.1421 26 42.5 22.6421 42.5 18.5C42.5 14.3579 39.1421 11 35 11",
    stroke: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 15.582,
    r: 3.5,
    stroke: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 34,
    r: 1.5,
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.279 16.5786L30.5305 17.7035C30.7616 17.8982 30.9161 18.17 30.9658 18.4697C31.0156 18.7693 30.9575 19.0771 30.8019 19.3372L29.2928 21.9393C29.1757 22.1385 29.0086 22.3029 28.8082 22.4158C28.6056 22.529 28.3781 22.5891 28.1465 22.5905C28.0028 22.5914 27.8599 22.5697 27.7228 22.5262L26.121 21.9924C25.8404 22.1741 25.5488 22.3366 25.246 22.4801L24.9096 24.1193C24.8473 24.4209 24.681 24.6903 24.4403 24.8796C24.1965 25.0722 23.8942 25.1739 23.5847 25.1675H20.4599C20.1504 25.1739 19.8481 25.0722 19.6043 24.8796C19.3641 24.6901 19.1983 24.4207 19.1364 24.1193L18.7986 22.4801C18.4998 22.3347 18.2099 22.1714 17.9305 21.991L16.3231 22.5262C16.1861 22.5697 16.0431 22.5914 15.8995 22.5905C15.6684 22.5888 15.4413 22.5288 15.2391 22.4158C15.039 22.3033 14.8718 22.1394 14.7545 21.9407L13.1915 19.3372C13.029 19.0747 12.9669 18.7614 13.0168 18.4561C13.0668 18.1507 13.2254 17.8742 13.4628 17.6784L14.713 16.0839V15.5892L13.4614 14.4642C13.2303 14.2695 13.0759 13.9978 13.0261 13.6981C12.9763 13.3984 13.0345 13.0907 13.1901 12.8306L14.7531 10.2285C14.8702 10.0293 15.0374 9.86487 15.2377 9.75192C15.4399 9.63896 15.667 9.5789 15.8981 9.57723C16.0405 9.56817 16.1834 9.58137 16.3217 9.61636L17.8973 10.1754C18.1788 9.99368 18.4704 9.83111 18.7723 9.68763L19.1101 8.0484C19.172 7.74706 19.3378 7.47766 19.578 7.28817C19.8218 7.09552 20.1241 6.99382 20.4336 7.00029H23.532C23.8416 6.99382 24.1438 7.09552 24.3876 7.28817C24.6299 7.47962 24.7961 7.74934 24.8556 8.0484L25.1934 9.68763C25.4934 9.83204 25.7827 9.99508 26.0615 10.1767L27.6702 9.64291C27.8488 9.58429 28.0374 9.5637 28.2243 9.58246C28.4111 9.60123 28.592 9.65893 28.7556 9.75192C28.9564 9.86651 29.1225 10.0314 29.2402 10.2271L30.8019 12.8306C30.9666 13.0908 31.0318 13.4026 30.9854 13.7079C30.9391 14.0131 30.7843 14.2909 30.5499 14.4894L29.279 15.5822V16.5786Z",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35 26C34.5 28.8333 32.1 34.5 26.5 34.5",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItSupportANdMaintainanceIcon);
export default __webpack_public_path__ + "static/media/itSupportANdMaintainanceIcon.c0d08c33fb449d17d66def52b5041a44.svg";
export { ForwardRef as ReactComponent };